<template>
    <div>
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{name:'home'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">{{ title }}</div>
        </div>
        <div id="appCapsule">
            <div class="section full mt-1 mb-5">
                <div class="wide-block p-3">
                    <div class="text-center mt-5">
                        <img :src="require('@/assets/image/403.svg')" alt="403" class="w-75 mb-3"><br>
                        <i>Anda tidak mempunyai akses untuk halaman ini. Halaman ini hanya bisa di akses oleh <b>DIGI Premium</b></i>
                    </div>
                </div>
            </div>
            <div class="form-button-group">
                <router-link :to="{name:'account.upgrade'}" class="btn btn-primary btn-block btn-lg">Upgrade DIGI Premium</router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title'],
    mounted() {
        if(this.title == undefined){
            this.$router.push({name:'home'})
        }
    },
}
</script>